import { useSelector, useDispatch } from 'react-redux';
import { selectPromoBannerInfo } from '../../../../../reducers/v2/promotion/selectors/selectPromoBannerInfo';
import { loadPublishTerms } from '../../../../../thunks/publishTerms/loadPublishTerms';

export const usePromoDiscountBanner = () => {
  const promoDiscountBanner = useSelector(selectPromoBannerInfo);
  const dispatch = useDispatch();

  const resetBanner = () => {
    dispatch(loadPublishTerms());
  };

  return {
    title: promoDiscountBanner?.title,
    endDate: promoDiscountBanner?.endDate,
    resetBanner,
  };
};
